/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type PostType from '@linc-technologies/linced-common/enums/post-type';
import type ReactionType from '@linc-technologies/linced-common/enums/reaction-type';
import type Comment from '@linc-technologies/linced-common/models/posts/comment';
import type Post from '@linc-technologies/linced-common/models/posts/post';

// Proto: posts.Reaction.
export default class Reaction extends Model {
  declare [Type]: 'posts/reaction';

  @attr('number')
  declare createTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare schoolId: string;

  @attr('number', { defaultValue: 0 })
  declare postType: EnumValue<typeof PostType> | 0;

  @belongsTo('posts/post', { async: true, inverse: 'reactions' })
  declare postId: AsyncBelongsTo<Post>;

  @belongsTo('posts/comment', { async: true, inverse: 'reactions' })
  declare commentId: AsyncBelongsTo<Comment>;

  @attr('string', { defaultValue: '' })
  declare authorId: string;

  @attr('number', { defaultValue: 0 })
  declare type: EnumValue<typeof ReactionType> | 0;

  @alias('type')
  declare reactionType: EnumValue<typeof ReactionType> | 0 | undefined;

  @attr('number', { defaultValue: 0 })
  declare reaction: number;
}
